import { CreateRedoDocumentationSchema } from "@redotech/redo-model/redo-documentation";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const createRedoDocumentation = {
  name: "createRedoDocumentation" as const,
  input: CreateRedoDocumentationSchema,
  output: z.object({ id: zExt.objectId() }),
};
